import React from 'react';
import NoteCard from 'views/notepad/tab_notes/viewComponents/note_card';

const EmbeddedNotepadNoteCard = ({ note, onClick, viewMode = 'preview' }) => (
  <NoteCard note={note} onClick={onClick} viewMode={viewMode} />
);

export default EmbeddedNotepadNoteCard;
